import { render, staticRenderFns } from "./HowToParticipate.vue?vue&type=template&id=3a4b8529&"
import script from "./HowToParticipate.vue?vue&type=script&lang=js&"
export * from "./HowToParticipate.vue?vue&type=script&lang=js&"
import style0 from "./HowToParticipate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports